/**
 * Mobile / PWA: keep focused fields visible above the on-screen keyboard.
 * Use with scrollable Modal.Body or report cards (maxHeight + overflowY).
 */

export const INVENTORY_MODAL_BODY_SCROLL_STYLE = {
  maxHeight: 'min(72vh, 720px)',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

/** Long report / detail forms inside the page (not modal) */
export const INVENTORY_REPORT_CARD_SCROLL_STYLE = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '5px',
  maxHeight: 'calc(100dvh - 140px)',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

export function handleFocusInScrollField(ev) {
  const t = ev.target;
  if (!t || typeof t.matches !== 'function') return;
  if (!t.matches('input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select')) {
    return;
  }
  window.requestAnimationFrame(() => {
    try {
      t.scrollIntoView({ block: 'center', behavior: 'smooth', inline: 'nearest' });
    } catch (_) {
      /* ignore */
    }
  });
}
